<mat-card class="container-fluid card-container">
  <div class="frame app-reference-card">
    <mat-icon class="image" svgIcon="reference"></mat-icon>
    <p class="paragraph-medium-regular">{{ desc }}</p>
    <app-button
      class="padBtn"
      name="{{ btnLabel }}"
      (click)="!disabled && handleClick()"
      *ngIf="btnLabel && !isBudgetSummary"
      [disabled]="disabled"
      [type]="type"
      [icon]="icon"
    ></app-button>
    <!-- this is literally just for the recommended acl/asl button in vendors...-->
    <app-button
      class="padBtn aslAclBtn"
      name="{{ btnLabelTwo }}"
      (click)="!disabled && handleAclAsl()"
      *ngIf="!isBudgetSummary && hasExtraButton && btnLabelTwo"
      [disabled]="disabled"
      [icon]="iconTwo"
      [type]="type"
      ><mat-icon>warning</mat-icon></app-button
    >
  </div>
</mat-card>
